export const canvasResizer = (canvas: HTMLCanvasElement, newWidth: number, newHeight: number) => {
  const scaledCanvas = document.createElement('canvas');
  const context = <CanvasRenderingContext2D>scaledCanvas.getContext('2d');

  scaledCanvas.width = newWidth;
  scaledCanvas.height = newHeight;

  context.scale(newWidth / canvas.width, newHeight / canvas.height);
  context.fillStyle = '#fff';
  context.fillRect(0, 0, newWidth, newHeight);
  context.drawImage(canvas, 0, 0);

  return scaledCanvas;
};
